<div *ngIf="!embedded">
  <div class="stick-top">
    <mat-toolbar *ngIf="!selectionMode">
      <mat-icon>sms</mat-icon> Incoming SMS
    </mat-toolbar>
    <div class="hbox lightly-padded button-bar">
      <button mat-raised-button (click)="reload()"><mat-icon>refresh</mat-icon> Refresh</button>&nbsp;
      <micro-checkbox [(checked)]="settings.autoRefresh" negative="Auto-Refresh" positive="Auto-Refreshing" (click)="saveSettings()"></micro-checkbox>
      <div class="fill-space"></div>
      <micro-date-range [(unit)]="usageFilter.dateRangeUnit" [(from)]="usageFilter.from" [(fromInfinite)]="usageFilter.fromInfinite" [(until)]="usageFilter.until" [(untilInfinite)]="usageFilter.untilInfinite" ></micro-date-range>
    </div>
  </div>
  <micro-do-chart *ngIf="!selectionMode" [smallChart]="true" [doChartFilter]="usageFilter" dateField="receivedAt" entityType="SMS_MO" filter="" groupBy="anumberId"></micro-do-chart>
</div>

<div *ngIf="embedded">
  <div class="stick-top">
    <div class="hbox lightly-padded button-bar">
      <button mat-raised-button (click)="reload()"><mat-icon>refresh</mat-icon> Refresh</button>
    </div>
  </div>
</div>

<div [ngClass]="{'padded': !selectionMode}">
  <mat-radio-group [(ngModel)]="selectedRow" (ngModelChange)="onSelectedRowChange()">
    <table class="basicTable">
      <thead>
      <tr>
        <th *ngIf="selectionMode" style="width: 30px;"></th>
        <th class="dateTimeHeader">
          <div class="vbox">
            Received At
          </div>
        </th>
        <th *ngIf="auth.hasRole('COMPANY_ADMIN')">
          <div class="vbox">
            Company
            <micro-company-select [(companyId)]="filter.companyId"></micro-company-select>
          </div>
        </th>
        <th class="msisdnHeader">
          <div class="vbox">
            From
            <input [(ngModel)]="filter.from">
          </div>
        </th>
        <th class="msisdnHeader">
          <div class="vbox">
            To
            <input [(ngModel)]="filter.to">
          </div>
        </th>
        <th>
          <div class="vbox">
            Text
            <input [(ngModel)]="filter.text">
          </div>
        </th>
        <th>
          <div class="vbox">
            A-Number
            <micro-anumber-select [(anumberId)]="filter.anumberId"></micro-anumber-select>
          </div>
        </th>
        <th>
          <div class="vbox">
            MAO
          </div>
        </th>
        <th>
          <div class="vbox">
            MNO
            <micro-mno-select [(mnoId)]="filter.mnoId"></micro-mno-select>
          </div>
        </th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let element of dataSource.data">
        <td *ngIf="selectionMode">
          <mat-radio-button [value]="element"></mat-radio-button>
        </td>
        <td *ngIf="!embedded" [matTooltip]="element.receivedAt"><a routerLink="/sms/incoming/{{element.id}}">{{element.receivedAt|dateTimeMs}}</a></td>
        <td *ngIf="embedded" [matTooltip]="element.receivedAt"><a (click)="dialogService.openDetail({objectType: 'SmsMo', objectId: element.id})">{{element.receivedAt|dateTimeMs}}</a></td>
        <td *ngIf="auth.hasRole('COMPANY_ADMIN')"><micro-company-lookup [companyId]="element.companyId"></micro-company-lookup></td>
        <td [matTooltip]="element.from">{{element.from}}</td>
        <td [matTooltip]="element.to">{{element.to}}</td>
        <td [matTooltip]="element.text">{{element.text}}</td>
        <td>
          <micro-anumber-lookup [anumberId]="element.anumberId"></micro-anumber-lookup>
        </td>
        <td>
          <micro-mao-lookup [maoId]="element.anumberMaoId"></micro-mao-lookup>
        </td>
        <td>
          <micro-mno-lookup [mnoId]="element.mnoId"></micro-mno-lookup>
        </td>
      </tr>
      <tr *ngIf="dataSource.data?.length === 0">
        <td colspan="100"><em>No results found</em></td>
      </tr>
      </tbody>
      <tfoot>
      <tr>
        <td colspan="100">
          <mat-paginator #paginator
                         (page)="pagignatorChanged()"
                         [pageSize]="settings.pageSize"
                         [pageSizeOptions]="[25, 50, 100, 250]">
          </mat-paginator>
        </td>
      </tr>
      </tfoot>
    </table>
  </mat-radio-group>
</div>
